<script>
import Layout from "../../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Area from "@/components/c-input-area";
import Select from "@/components/c-select";
import Loading from "@/components/c-loading";
import { sellerService } from "../../../../../services/saleservice/seller.service";
import { userService } from "../../../../../services/authservice/user.service";
import { servicehelpers } from "../../../../../services/servicehelpers";
import i18n from "../../../../../i18n";

/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "User Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
    Area,
    Select, 
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Seller",
      breadCrumb: {},
      sellerData: null,
      typeList: {},
      roleList: {},

      valueCode: '',
      valueType: 0,
      valueName: '',
      valueNameEn: '',
      valuePhone1: '',
      valuePhone2: '',
      valueEmail: '',
      valueAddress: '',
      valueAddressEn: '',
      valuePhoto: [],

      valueWithUser: 0,
      valueUserName: '',
      valuePassword: '',
      valueConfirmPassword: '',
      password: '',
      confirm: '',
      valueRole: 0,
      roleDataList: {},

    };
  },
  mounted() {
    this.loadingRoleData();

    let hasId = 'id' in this.$route.params;
    this.isAdd = !hasId;
    this.fetchingStats = !hasId;

    if(hasId) {
      this.loadingData(this.$route.params.id);     

    } 
  },

  methods: {

    loadingData: function(id) {
      this.fetchingStats = false;
      sellerService.getOne(id)
        .then(response => {
            this.breadCrumb = {
              text: response.data.name + " - (" + response.data.code + ")",
              active: true,
            };

          this.fetchingStats = true;
          this.sellerData = response;


        console.log(this.isAdd);
          // console.log(JSON.stringify(this.sellerData));

          this.valueCode = this.sellerData.data.code;
          this.valueType = this.sellerData.data.type_id;
          this.valueName = this.sellerData.data.name;
          this.valueNameEn = this.sellerData.data.name_en;
          this.valuePhone1 = this.sellerData.data.phone_no_1.trim() == '' ? this.sellerData.data.phone : this.sellerData.data.phone_no_1;
          this.valuePhone2 = this.sellerData.data.phone_no_2;
          this.valueEmail = this.sellerData.data.email;
          this.valueAddress = this.sellerData.data.address;
          this.valueAddressEn = this.sellerData.data.address_en;
          this.valuePhoto = [];

          this.valueWithUser = 0;
          if(this.sellerData.data.username != null) {
            this.valueWithUser = 1;

            this.valueUserName = this.sellerData.data.username;
            this.valueRole = this.sellerData.data.role_id;
          }

        });
    },

    loadingRoleData: function() {

      servicehelpers.getRoleData().then(response => {
        this.roleList = response;
      });
    },

    submitCancel: function() {

      // console.log(this.dataType);

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "setting-security-user"
          });

        }
      });
      
    },

    submitSave: function() {

      this.tryingToSubmit = true;

      let user = {
        name: this.valueName,
        sex: 1,
        phone: this.valuePhone1,
        email: this.valueEmail == '' ? this.valueUserName : this.valueEmail,
        email_verified_at: this.$moment().clone().format('YYYY-MM-DD'),
        address: this.valueAddress,
        username: this.valueUserName,
        // password: this.valuePassword,
        is_verified: 1,
        verify_code: '',
        role_id: this.valueRole,
        is_system: 0,
        login_enable: 1,
        remember_token: '',
        photo: '',
        manage_type: 1
      };

      let seller = {
        type_id: 1,
        parent_id: 0,
        user_id: 0,
        code: this.valueCode,
        name: this.valueName,
        name_en: this.valueNameEn == '' ? this.valueName : this.valueNameEn,
        phone_no_1: this.valuePhone1,
        phone_no_2: this.valuePhone2,
        email: this.valueEmail,
        address: this.valueAddress,
        address_en: this.valueAddressEn,
        photo: this.valuePhoto.length == 0 ? '' : this.valuePhoto[0],
      };

      if(this.isAdd) {
        if(this.valueWithUser == 1) {          
          // this.saveChangedUser(('id' in user), user, (result) => {
          this.saveChangedUser(this.isAdd, user, (result) => {

            seller.user_id = result.id;
            sellerService.insert(seller).then(response => {
              this.tryingToSubmit = false;
              if(response.status == 200) {
                  this.success();
              }
              
            });
          });

        } else {
          sellerService.insert(seller).then(response => {
            this.tryingToSubmit = false;
            if(response.status == 200) {
                this.success();
            }
          });
        }

      } else {

        if(this.valueWithUser == 1) {

          if(this.sellerData.user_id != 0) {
            // console.log("ddddddddd");
            this.saveChangedUser(this.isAdd, user, (result) => {
              seller.user_id = result.id;

              console.log(result);

              sellerService.update(this.$route.params.id, seller).then(response => {
                this.tryingToSubmit = false;
                if(response.status == 200) {
                  this.success();
                }
              });
            });

          } else {

            sellerService.update(this.$route.params.id, seller).then(response => {
              this.tryingToSubmit = false;
              if(response.status == 200) {
                if(this.sellerData.user_id != this.valueRole) {
                  // Update User Role
                  userService.changeRole(user).then(response => {
                    console.log(response);
                  });
                }

                this.success();
              }
              
            });

          }

        } else {
        
          sellerService.update(this.$route.params.id, seller).then(response => {
            this.tryingToSubmit = false;
            if(response.status == 200) {
              if(this.sellerData.user_id != 0) {
                // Delete User Login
                userService.deleteLogin(this.sellerData.user_id).then(response => {
                  console.log(response);
                });
              }

              this.success();
            }
            
          });
        }

      }
    },

    changePassword: function() {
      if(this.password.length < 8){
        alert('សូមបញ្ជូលេខកូដយ៉ាងតិច ៨ខ្ទង់');
      }else if(this.password != this.confirm) {
        alert('លេខសម្ងាត់ និងការបញ្ជាក់មិនដូចគ្នាទេ សូមព្យាយាមម្តងទៀត');
      }else{

        let user = {
          seller_id : this.$route.params.id,
          password: this.password
        }
        userService.changePassword(user).then(response => {
          var sms = response.message;
          alert(sms);
          this.password = "";
          this.confirm = "";
        });
      }
    },

    success: function() {
      this.clearForm();
      this.$swal.fire({
        title: i18n.t('general.success.title'),
        text: i18n.t('general.success.message'),
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.success.yes'),
        cancelButtonText: i18n.t('general.success.no')
      }).then(result => {
        if (!result.value) {
          this.$router.push(this.$route.query.redirectFrom || {
            name: "setting-security-user"
          });
        } 
      });
    },

    clearForm: function() {
      this.valueCode = '';
      this.valueType = 0;
      this.valueName = '';
      this.valueNameEn = '';
      this.valuePhone1 = '';
      this.valuePhone2 = '';
      this.valueEmail = '';
      this.valueAddress = '';
      this.valueAddressEn = '';
      this.valuePhoto = [];

      this.valueUserName = '';
      this.valuePassword = '';
      this.valueConfirmPassword = '';
      this.valueRole = 0;
      
    }, 

    saveChangedUser: function(isAdd, user, callback) {
      if(isAdd) {

        userService.register(user).then(response => {
          callback(response);
        });

      } else {

        userService.changeRole(user).then(response => {
          callback(response);
        });
      }
    },

    uploadPhotoSuccess(file, response) {
        // console.log("FFFFF", file);
        this.dataPhoto = [response.data];

        // console.log("#####", this.dataPhoto);
    },
    
    uploadDocSuccess(file, response) {
        // console.log(file);
        // this.dataDoc.push(response.data);

        if(response.data != null) {
          this.dataDoc.push({
            path: response.data
          });
        }
    },
    
  }
};
</script>

<template>
  <Layout>
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('setting.security.user.list'),
        href: '/setting/security/user',
      }, {
        text: $t('setting.security.user.new'),
        active: true
      }]" :title="this.isAdd ? $t('setting.security.user.new') : $t('setting.security.user.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('setting.security.user.list'),
        href: '/setting/security/user',
      }, this.breadCrumb]" :title="this.isAdd ? $t('setting.security.user.new') : $t('setting.security.user.edit')" />
    </div>

    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <div class="row">
                <div class="col-md-3">
                  <Input 
                    :type="'password'"
                    v-model="password"
                    :label="'general.password'" 
                    :require="true"
                     /> 
                </div>
                <div class="col-md-3">
                  <Input 
                    :type="'password'"
                    v-model="confirm"
                    :label="'general.confirm_password'" 
                    :require="true" />
                  </div>
                  <div class="col-md-3 mt-4">
                    <Button v-bind:icon="'bx bx-save bx-tada'" 
                      v-bind:buttonType="'button'"
                      @click="changePassword()"
                      v-bind:requesting="tryingToSubmit"
                      v-bind:title="$t('general.save')"  />
                  </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'code'"
                    :disabled="true"
                    v-model="valueCode"
                    :label="'seller.code'"
                     /> 
                </div>
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'name'"
                    v-model="valueName"
                    :require="true"
                    :label="'seller.name'"  />
                </div>
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'name_en'"
                    v-model="valueNameEn"
                    :label="'seller.name-en'"  />
                </div>

              </div>
              <div class="row">
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'phone_no_1'"
                    v-model="valuePhone1"
                    :mask="'### ### ########'"
                    :require="true"
                    :label="'seller.phone-no-1'"  />
                </div>
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'phone_no_2'"
                    :mask="'### ### ########'"
                    v-model="valuePhone2"
                    :label="'seller.phone-no-2'"  />
                </div>
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'email'"
                    v-model="valueEmail"
                    :label="'seller.email'"  />
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <Area 
                    :rows="5"
                    :id="'address'"
                    v-model="valueAddress"
                    :label="'seller.address'"  />
                </div>
                <div class="col-lg-6">
                  <Area 
                    :rows="5"
                    :id="'address_en'"
                    v-model="valueAddressEn"
                    :label="'seller.address-en'"  />
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12">

                  <div inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
                    </div>
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
                    </div>
                  </div>
    
                </div>
              </div>
          
          </div>
        </div>
      </div>

      <div class="col-lg-4">
  
        <div class="card">
          <div class="card-body">
              <div >
                <div class="row">
                  <div class="col-md-12">
                    <Input 
                      :type="'text'"
                      :id="'username'"
                      :editable="isAdd ? true : false"
                      v-model="valueUserName"
                      :label="'seller.user.username'"  />
                  </div>
                  
                </div>
                <div class="row" v-show="isAdd">
                  <div class="col-md-12">
                    <Input 
                      :type="'text'"
                      :id="'password'"
                      v-model="valuePassword"
                      :label="'seller.user.password'"  />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <Select 
                      :text="'name'"
                      :id="'type_id'"
                      :text2="'name_en'"
                      :list="this.roleList"
                      v-model="valueRole"
                      :label="'seller.user.role'"
                      /> 
                  </div>
                </div>
              </div>
          </div>
        </div>

      </div>
    </b-form> 
  
  </Layout>
</template>